module.exports = __webpack_public_path__ + "assets/img/1.358dc442.png";